/* Learn page scroll-spy + smooth scroll.
 * - Scroll spy: adds .active to the link whose section is currently under
 *   the combined (theme header + in-page nav) offset.
 * - Smooth scroll: clicking a nav link scrolls to its target with the same
 *   offset so the section heading lands flush below the sticky nav.
 * Reads --header-height (set by sections/header.liquid's StickyHeader).
 */
(function () {
  function init() {
    var nav = document.querySelector('.learn-page-nav');
    if (!nav) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;

    var targets = links
      .map(function (link) {
        var id = link.getAttribute('href').slice(1);
        if (!id) return null;
        var el = document.getElementById(id);
        return el ? { link: link, el: el } : null;
      })
      .filter(Boolean);

    if (!targets.length) return;

    function getHeaderHeight() {
      var h = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
        10
      );
      return isNaN(h) ? 0 : h;
    }

    function getStickyOffset() {
      return getHeaderHeight() + nav.offsetHeight;
    }

    // Smooth-scroll click handling — offsets so the target lands below the sticky nav.
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var rect = target.getBoundingClientRect();
        var scrollY = window.scrollY || window.pageYOffset;
        var top = rect.top + scrollY - getStickyOffset() - 4;
        window.scrollTo({ top: top, behavior: 'smooth' });
        // Update hash without jump
        if (history.pushState) {
          history.pushState(null, '', '#' + id);
        }
      });
    });

    var ticking = false;

    function update() {
      var offset = getStickyOffset() + 20;
      var scrollY = window.scrollY || window.pageYOffset;
      var current = null;

      for (var i = 0; i < targets.length; i++) {
        var rect = targets[i].el.getBoundingClientRect();
        var top = rect.top + scrollY;
        if (top - offset <= scrollY) {
          current = targets[i];
        } else {
          break;
        }
      }

      // If we haven't reached the first target yet, still highlight it.
      if (!current && targets.length) {
        var firstTop = targets[0].el.getBoundingClientRect().top + scrollY;
        if (scrollY >= firstTop - offset - 200) {
          current = targets[0];
        }
      }

      links.forEach(function (link) {
        link.classList.toggle('active', current !== null && link === current.link);
      });

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
